import { isMobileViewport } from '../../../../src/js/globals/utils/functions';

const blocks = document.querySelectorAll('.block-logo-grid-case-study');

blocks.forEach((block) => {
	const featuredItem = block.querySelector<HTMLElement>('.logo-grid__item--featured');
	const whiteItem = block.querySelector<HTMLElement>('.logo-grid__item--white');
	const caseStudy = block.querySelector<HTMLElement>('.case-study');
	const whiteItemSpacer = block.querySelector<HTMLElement>('.logo-grid__item--mobile');
	const horizontalTrack = block.querySelector<HTMLElement>('.horizontal-scroll-track');
	const horizontalTrackInner = block.querySelector<HTMLElement>(
		'.horizontal-scroll-track__inner'
	);
	if (
		!featuredItem ||
		!whiteItem ||
		!caseStudy ||
		!horizontalTrack ||
		!whiteItemSpacer ||
		!horizontalTrackInner
	) {
		return;
	}

	let originalTop = 0;
	let featuredHeight = 0;
	let caseStudyTop = 0;
	let caseStudyHeight = 0;
	let trackHeight = 0;
	let trackContentWidth = 0;
	let viewportWidth = 0;
	let headerOffset = 0;
	let logoOffsetFromCaseStudy = 0;
	let horizontalLogoPosition = 0;
	let maxLogoTranslate = 0;
	let horizontalScrollStart = 0;
	let horizontalReadHold = 0;
	let horizontalEndHold = 0;
	let desktopLayout = false;
	let animationFrame: number | null = null;
	let measurementRequired = true;
	let isActive = false;
	let lastLogoTranslate: number | null = null;
	let lastHorizontalTranslate: number | null = null;

	const getHeaderOffset = () => {
		const headerHeightFull = getComputedStyle(document.documentElement)
			.getPropertyValue('--headerHeightFull')
			.trim();
		return parseFloat(headerHeightFull) || 0;
	};

	const measure = () => {
		desktopLayout = Boolean(window.impBreakpoints && !isMobileViewport(window.impBreakpoints));

		featuredItem.style.transform = '';
		horizontalTrackInner.style.transform = '';
		horizontalTrackInner.style.paddingLeft = '';
		whiteItem.style.transform = '';
		lastLogoTranslate = null;
		lastHorizontalTranslate = null;

		if (desktopLayout) {
			const featuredRect = featuredItem.getBoundingClientRect();
			const caseStudyRect = caseStudy.getBoundingClientRect();

			viewportWidth = document.documentElement.clientWidth;
			originalTop = featuredRect.top + window.scrollY;
			featuredHeight = featuredRect.height;
			caseStudyTop = caseStudyRect.top + window.scrollY;
			logoOffsetFromCaseStudy = originalTop - caseStudyTop;
			horizontalLogoPosition = viewportWidth / 2 - featuredRect.width / 2;

			whiteItem.style.width = `${featuredRect.width}px`;
			whiteItem.style.height = `${featuredRect.height}px`;
			whiteItem.style.opacity = '1';
			whiteItemSpacer.style.width = `${featuredRect.width}px`;
			whiteItem.style.transform = `translate3d(${horizontalLogoPosition}px, ${logoOffsetFromCaseStudy}px, 0)`;

			const basePadding = parseFloat(getComputedStyle(horizontalTrackInner).paddingLeft);
			const spacerRect = whiteItemSpacer.getBoundingClientRect();
			const whiteItemRect = whiteItem.getBoundingClientRect();
			const spacerOffset = whiteItemRect.left - spacerRect.left;
			horizontalTrackInner.style.paddingLeft = `${basePadding + spacerOffset}px`;
		} else {
			whiteItem.style.width = '';
			whiteItem.style.height = '';
			whiteItem.style.opacity = '0';
			whiteItemSpacer.style.width = '';
		}

		const caseStudyRect = caseStudy.getBoundingClientRect();
		caseStudyTop = caseStudyRect.top + window.scrollY;
		caseStudyHeight = caseStudy.offsetHeight;
		trackHeight = horizontalTrack.offsetHeight;
		trackContentWidth = horizontalTrackInner.offsetWidth;
		viewportWidth = document.documentElement.clientWidth;
		headerOffset = getHeaderOffset();
		maxLogoTranslate = Math.max(
			0,
			caseStudyTop + trackHeight / 2 - originalTop - featuredHeight / 2
		);

		const caseStudyStyle = getComputedStyle(caseStudy);
		const readHoldVh =
			parseFloat(caseStudyStyle.getPropertyValue('--horizontal-scroll-read-hold')) || 0;
		const endHoldVh =
			parseFloat(caseStudyStyle.getPropertyValue('--horizontal-scroll-end-hold')) || 0;
		horizontalReadHold = (window.innerHeight * readHoldVh) / 100;
		horizontalEndHold = (window.innerHeight * endHoldVh) / 100;
		horizontalScrollStart = desktopLayout
			? originalTop + featuredHeight / 2 - window.innerHeight / 2 + maxLogoTranslate
			: caseStudyTop - headerOffset;
	};

	const getHorizontalTranslate = (scrollY: number) => {
		const scrollableHeight = Math.max(
			1,
			caseStudyHeight - trackHeight - horizontalReadHold - horizontalEndHold
		);
		const scrollProgress = Math.max(
			0,
			Math.min(1, (scrollY - horizontalScrollStart - horizontalReadHold) / scrollableHeight)
		);
		const maxHorizontalTranslate = Math.max(0, trackContentWidth - viewportWidth);

		return scrollProgress * maxHorizontalTranslate;
	};

	const render = (horizontalTranslate: number) => {
		const scrollY = window.scrollY;

		if (desktopLayout) {
			const activationScroll = originalTop + featuredHeight / 2 - window.innerHeight / 2;
			const logoTranslate = Math.max(
				0,
				Math.min(scrollY - activationScroll, maxLogoTranslate)
			);

			if (logoTranslate !== lastLogoTranslate) {
				featuredItem.style.transform = `translate3d(0, ${logoTranslate}px, 0)`;
				whiteItem.style.transform = `translate3d(${horizontalLogoPosition}px, ${
					logoOffsetFromCaseStudy + logoTranslate
				}px, 0)`;
				lastLogoTranslate = logoTranslate;
			}
		}

		if (horizontalTranslate !== lastHorizontalTranslate) {
			horizontalTrackInner.style.transform = `translate3d(-${horizontalTranslate}px, 0, 0)`;
			lastHorizontalTranslate = horizontalTranslate;
		}
	};

	const update = () => {
		animationFrame = null;

		if (measurementRequired) {
			measure();
			measurementRequired = false;
		}

		const targetHorizontalTranslate = getHorizontalTranslate(window.scrollY);
		render(targetHorizontalTranslate);
	};

	const scheduleUpdate = (remeasure = false) => {
		measurementRequired = measurementRequired || remeasure;

		if (animationFrame === null) {
			animationFrame = requestAnimationFrame(update);
		}
	};

	const handleScroll = () => scheduleUpdate();

	const observer = new IntersectionObserver(
		([entry]) => {
			isActive = entry.isIntersecting;
			block.classList.toggle('is-scroll-active', isActive);

			if (isActive) {
				window.addEventListener('scroll', handleScroll, { passive: true });
				scheduleUpdate(true);
				return;
			}

			window.removeEventListener('scroll', handleScroll);
		},
		{ rootMargin: '600px 0px' }
	);

	observer.observe(block);
	window.addEventListener('resize', () => scheduleUpdate(true), { passive: true });
	window.addEventListener('load', () => scheduleUpdate(true), { passive: true });
	document.fonts?.ready.then(() => scheduleUpdate(true));
	scheduleUpdate(true);
});
